<template>
    <b-card no-body class="h-100">
        <b-card-body>
            <h5 class="heading-1 mb-3">
                <span>ITENS DO CONTRATO</span>
            </h5>
            <b-form-input
                type="text"
                placeholder="Buscar item..."
                v-model="busca"
                class="mb-3"
            ></b-form-input>
            <p class="text-muted" v-if="itensFiltrados.length === 0">
                Nenhum item a exibir
            </p>
            <b-list-group class="lista-itens">
                <b-list-group-item
                    v-for="item in itensFiltrados"
                    :key="item.idItem"
                    :active="emFoco(item)"
                    class="item-selecao"
                    @click="$emit('focar', item)"
                >
                    <div class="d-flex align-items-start">
                        <div class="mr-2" @click.stop>
                            <b-form-checkbox
                                v-if="!item.possuiSubitens"
                                :checked="estaSelecionado(item)"
                                :disabled="travado(item)"
                                :title="tituloCheckbox(item)"
                                @change="$emit('alternar', item)"
                            ></b-form-checkbox>
                            <i v-else class="fa fa-folder-o mt-1"></i>
                        </div>
                        <div class="flex-grow-1">
                            <div>{{ item.ordem }} — {{ item.descricao }}</div>
                            <small v-if="item.possuiSubitens">
                                {{ item.quantidadeSubitensNaoIntegrados }}
                                {{
                                    item.quantidadeSubitensNaoIntegrados === 1
                                        ? 'subitem não integrado'
                                        : 'subitens não integrados'
                                }}
                            </small>
                            <small v-else-if="travado(item)">
                                <b-badge :variant="variante(item)">{{
                                    descricaoStatus(item)
                                }}</b-badge>
                            </small>
                        </div>
                        <i
                            class="fa fa-chevron-right mt-1"
                            v-if="item.possuiSubitens"
                        ></i>
                    </div>
                </b-list-group-item>
            </b-list-group>
        </b-card-body>
    </b-card>
</template>

<script>
import {
    obterStatusIntegracao,
    estaTravado,
    motivoBloqueio
} from './StatusIntegracao'

export default {
    props: {
        itens: {
            type: Array,
            default: () => []
        },
        itemEmFoco: {
            type: Object,
            default: null
        },
        selecao: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            busca: ''
        }
    },

    computed: {
        itensFiltrados() {
            if (!this.busca) {
                return this.itens
            }
            let termo = this.busca.textoNormalizado()
            return this.itens.filter((item) => {
                let texto = `${item.ordem} ${item.descricao}`
                return texto.textoNormalizado().indexOf(termo) !== -1
            })
        }
    },

    methods: {
        emFoco(item) {
            return (
                this.itemEmFoco && this.itemEmFoco.idItem === item.idItem
            )
        },

        estaSelecionado(item) {
            return this.selecao.some((selecionado) => {
                return selecionado.idItem === item.idItem
            })
        },

        travado(item) {
            return estaTravado(item.statusIntegracao)
        },

        tituloCheckbox(item) {
            return this.travado(item) ? motivoBloqueio(item.statusIntegracao) : ''
        },

        descricaoStatus(item) {
            return obterStatusIntegracao(item.statusIntegracao).descricao
        },

        variante(item) {
            return obterStatusIntegracao(item.statusIntegracao).variant
        }
    }
}
</script>

<style scoped>
.lista-itens {
    max-height: 60vh;
    overflow-y: auto;
}
.item-selecao {
    cursor: pointer;
}
</style>
